var _style, _script, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStackIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 17",
    style: {
      enableBackground: "new 0 0 18 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#F79317;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _script || (_script = /*#__PURE__*/React.createElement("script", {
    "data-extension-id": "dlcobpjiigpikoobohmabehhmhfoodbb",
    id: "argent-x-extension",
    xmlns: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.7,3.2v2.7c0,1.1,1.8,2,4,2s4-0.9,4-2V3.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.7,5.8v2.7c0,1.1,1.8,2,4,2c1,0,2-0.2,2.7-0.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.7,8.5v2.7c0,1.1,1.8,2,4,2c1,0,2-0.2,2.7-0.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.7,5.2c2.2,0,4-0.9,4-2s-1.8-2-4-2s-4,0.9-4,2S3.5,5.2,5.7,5.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.3,8.5v2.7c0,1.1,1.8,2,4,2s4-0.9,4-2V8.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.3,11.2v2.7c0,1.1,1.8,2,4,2s4-0.9,4-2v-2.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,10.5c2.2,0,4-0.9,4-2s-1.8-2-4-2c-2.2,0-4,0.9-4,2S10.1,10.5,12.3,10.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackIco);
export default __webpack_public_path__ + "static/media/stack-ico.8dd049ff619937c01dde200791888eba.svg";
export { ForwardRef as ReactComponent };